import Rete from 'rete';
import LabelText from "./components/LabelText";

export class LabelTextControl extends Rete.Control {

    static get DEFAULT_VALUE() { return ""; };

    constructor(editor, key, node, readonly = false, labelText) {
        super(key);
        // this.render = 'react'; // required?
        this.key = key;
        this.component = props => (
            <LabelText {...props} />
        );

        const initial = node.data[key] || LabelTextControl.DEFAULT_VALUE;
        node.data[key] = initial;

        this.props = {
            readonly,
            editor,
            value: initial,
            // putData: (key: string, data: unknown) => this.putData(key, data),
            putData: (data) => this.putData(this.key, data),
            labelText: labelText,
        };
    }
}